import type { TourTranslation } from "./index";

export const english = {
  ap_label: "Accounting",
  ap_intro_title: "Invoicing in accounting teams",
  ap_intro_lead: "This Is A Demo Of Invoicing In Accounting Teams.",
  ap_intro_body:
    "Invoice processing is increasingly automated, but exceptions still require manual work. The key metric is manual touches per invoice. But how do you identify the upstream failures causing them?",
  ap_failures_body:
    "Platonic maps your workflows, revealing three failure modes: PO price mismatches, quantity mismatches, and missing receipts.",
  ap_filter_body:
    "Price mismatches can reveal upstream process failures. Platonic lets you zoom in by describing them in plain language.",
  ap_filter_prompt: "PO Invoice price mismatch",
  ap_ask_body: "Manual investigation can be time-consuming, let's ask directly to the processes.",
  ap_prompt: "Why is there a price mismatch between POs and invoices?",
  ap_answer_body:
    "The chat revealed that a few items drive most exceptions: outdated contracts in the PO system cause recurring invoice mismatches.",
  ap_monitor_body:
    "Updating the affected POs fixes the issue, but it can recur with other contracts. How do you catch it early?",
  ap_watch_prompt: "Find a list of items that lead to recurring invoice PO price mismatch.",
  ap_watch_title: "POs not updated",
  ap_kpi_body:
    "Platonic lets you track POs not updated as a KPI, with a periodic report straight to your inbox",
  hr_label: "Private Equity",
  hr_intro_title: "Key-person risk in HR teams",
  hr_intro_body:
    "A private equity fund has acquired a company. Before centralizing, outsourcing, or redesigning HR, it needs to understand where critical knowledge sits and which processes depend on specific people.",
  hr_map_body: "Let's take the candidate screening process as an example…",
  hr_inspect_body:
    "…a quick inspection shows that employees often rely on each other when handling more complex cases.",
  hr_ask_body: "Platonic lets you ask the process directly and understand the context behind them.",
  hr_prompt: "Provide context on why a colleague was consulted in this task",
  hr_answer_body:
    "The chat revealed that one employee handles most of these cases and holds the critical knowledge needed to resolve edge cases.",
  hr_monitor_body:
    "But how can we detect the same pattern across all processes within the function?",
  hr_wask_body:
    "You can ask Platonic directly to analyze how work is distributed across the HR team and identify key-person risks and operational dependencies.",
  hr_watch_prompt:
    "Analyze how work is distributed across the HR team and identify any key-person risks or operational dependencies. Who holds unique process knowledge, who is most frequently relied on by colleagues, which activities depend disproportionately on specific individuals, and what risks would arise if one person were unavailable?",
  hr_wanswer_body:
    "The analysis confirmed that one employee is the HR team's operational hub, holding much of the knowledge needed to run its processes.",
  cs_label: "Customer Service",
  cs_intro_title: "Knowledge gaps in Customer Service",
  cs_intro_body:
    "Customer Service teams rely on knowledge bases and playbooks. When they're incomplete or outdated, cases take longer and require more searches, interactions, and escalations. How do you identify the gaps?",
  cs_filter_body:
    "Platonic lets you zoom in on specific cases by describing them in plain language.",
  cs_filter_prompt: "top 10 longest time",
  cs_node_body:
    "The longest cases spend disproportionate time searching the knowledge base. Let's inspect that step.",
  cs_insight_body:
    "These searches are slow and often lead to escalation instead of resolution, suggesting knowledge-base gaps. But which gaps are driving the problem?",
  cs_ask_body: "Platonic lets you ask the process directly.",
  cs_prompt: "Which gaps/ambiguity in the policies emerge from these processes?",
  cs_answer_body:
    "The analysis highlights recurring gaps around EU withdrawal rights, auto-renewals, reseller refunds, and legacy plans",
  cs_monitor_body: "Once the gaps are fixed, how do you know the new guidance is actually working?",
  cs_watch_prompt:
    "Find unresolved knowledge-base searches and the escalation rate that follows them. Highlight recurring topics where agents fail to find relevant guidance, and show whether these gaps improve over time.",
  cs_watch_title: "KB gaps",
  cs_kpi_body:
    "Platonic lets you track knowledge base gaps as a KPI, with a periodic report straight to your inbox",
  demo_label: "Procurement",
  demo_intro_lead: "This Is A Demo Of Cost Management In Procurement Teams.",
  demo_intro_body:
    "Procurement costs depend on negotiated contracts. Renegotiating weak terms or switching suppliers can cut costs substantially. But how do you find those opportunities?",
  start: "Start",
  demo_blueprint_body:
    "Platonic records screen activity, clicks, and application usage across your team, then turns it into a blueprint of how work actually gets done",
  demo_graph_body: "Real processes are hard to read…",
  demo_map_body: "Platonic maps your company's workflows.",
  demo_deviations_body:
    "A common deviation from the standard operating procedure is sourcing suppliers externally, this can drive up costs. Let's check whether it does.",
  demo_ask_body: "Platonic lets you ask the process directly.",
  demo_prompt:
    "Show a table of unique items with average cost for on-contract and off-contract suppliers",
  demo_watch_prompt:
    "Identify all purchases that used an external contractor while a contracted one was available",
  demo_watch_title: "Non-contracted Contractor Usage",
  demo_answer_body:
    "The data confirms that off-contract suppliers cost substantially more than contracted one.",
  demo_monitor_body: "The fix is to enforce contract use, but how do you monitor it?",
  demo_kpi_body:
    "Platonic lets you track off-contract purchases as a KPI, with a periodic report straight to your inbox",
  demo_cta_title: "Ready to dig in?",
  demo_cta_body: "See what Platonic finds in your own team's work.",
  demo_cta_hint: "You can book a live demo at any time with the button in the bottom right corner.",
  demo_book_demo: "Book a demo",
  demo_request_access: "Request access",
  demo_waitlist_name_placeholder: "Full name",
  demo_waitlist_email_placeholder: "Work email",
  demo_waitlist_area_label: "Which area would you like to improve with Platonic?",
  demo_waitlist_area_placeholder: "Select an area",
  demo_waitlist_area_other_placeholder: "Which one?",
  demo_waitlist_area_procurement: "Procurement",
  demo_waitlist_area_finance: "Finance",
  demo_waitlist_area_customer_service: "Customer Service",
  demo_waitlist_area_supply_chain: "Supply Chain",
  demo_waitlist_area_operations: "Operations",
  demo_waitlist_area_sales: "Sales",
  demo_waitlist_area_human_resources: "Human Resources",
  demo_waitlist_area_it: "IT",
  demo_waitlist_area_other: "Other",
  demo_waitlist_done_title: "You're on the waitlist.",
  demo_waitlist_done_body:
    "We'll review your request and send you setup instructions as soon as access is ready.",
  demo_waitlist_error: "Something went wrong. Please try again.",
  welcome_body: "Welcome! This demo includes limited functionality.",
  welcome_cta_prefix: "To access the full product capabilities ",
  welcome_cta_link: "book a demo",
  welcome_gallery: "Check out our Library of use cases to see Platonic in action.",
  target_missing_toast_title: "Tour ended",
  target_missing_toast_message:
    "That part of the app isn't available right now. Try again once there is data to show.",
  back: "Back",
  next: "Next",
  done: "Done",
  settings_title: "Demo Gallery",
  settings_help: "Explore how Platonic handles key challenges in your function",
  demo_user_import: "Demo users",
  demo_user_import_card_description:
    "Create a demo's people from one file, and remove the whole demo when it is done.",
  demo_user_import_description:
    "Each demo is its own company, so it can be filtered and deleted as one.",
  demo_user_credentials: "Credentials",
  demo_user_credentials_warning:
    "These passwords are shown once and are not stored anywhere readable. Download them now if you need them.",
  download_csv: "Download CSV",
  select_demo_company: "Select a company",
  demo_import: "Import a demo",
  demo_import_description:
    "Drop a folder holding a manifest.json and one analysis file per session. Re-dropping it is safe: people that already exist are skipped and sessions are updated in place.",
  demo_drop_folder: "Drop the demo folder here",
  demo_choose_folder: "or choose a folder",
  demo_import_action: "Import demo",
  demo_retry_failed: "Retry failed",
  demo_manifest_missing: "The folder needs a {{name}}.",
  demo_manifest_unreadable: "The manifest could not be read.",
  demo_bundle_summary: "{{users}} people · {{sessions}} sessions",
  demo_company_outside_band: "Company id {{id}} is outside the demo band {{min}}–{{max}}.",
  demo_owners_not_in_manifest:
    "These owners are not in the manifest and must already exist: {{owners}}",
  demo_files_missing: "{{count}} files named in the manifest are not in the folder: {{files}}",
  demo_session_progress: "{{done}} of {{total}} done",
  demo_failed_count: "{{count}} failed",
  demo_owner_unresolved: 'No user named "{{owner}}"',
  demo_file_unreadable: "The analysis file is not valid JSON",
  demo_no_owner: "no owner",
  demo_usernames_taken:
    "These usernames already belong to accounts outside this demo, so nothing was created: {{users}}",
  demo_users_skipped: "{{count}} people already existed and were left alone: {{users}}",
  demo_contents: "What the demos hold",
  demo_contents_description:
    "Only seeded people appear here, and only they can be deleted — a real account is never reachable from this page.",
  delete_demo_user: "Delete {{username}}",
  delete_demo_session: "Delete session",
  delete_whole_demo: "Delete all of {{name}}",
  n_sessions: "{{count}} sessions",
  n_sessions_one: "{{count}} session",
  no_demo_companies_to_delete:
    "No demo to delete yet. Companies holding real users never appear here.",
} satisfies TourTranslation;
